import React, { useEffect, useState } from "react";
import { AppraiserDashQuote } from "../../../api/ApiTypes.ts";
import { useQuotesApi } from "../../../context/ApiContext.tsx";
import { QuoteDashboardItem } from "../../../components/QuoteDashboardItem.tsx";
import {QuoteDashboardSkeletonItem} from "../../../components/QuoteDashboardSkeletonItem.tsx";

const EmptyState = () => (
    <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-lg text-gray-600">No open quotes available at this time</p>
        <p className="text-sm text-gray-500 mt-2">
            New quote requests will appear here when they become available
        </p>
    </div>
);

export const QuoteDashboard: React.FC = () => {
    const [dashQuotes, setDashQuotes] = useState<AppraiserDashQuote[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const appraiserApi = useQuotesApi();

    useEffect(() => {
        const fetchQuotes = async () => {
            setLoading(true);
            try {
                const data = await appraiserApi.getQuotes();
                setDashQuotes(data);
            } catch (err) {
                console.error("Failed to fetch quotes links:", err);
                setDashQuotes([]);
            } finally {
                setLoading(false);
            }
        };

        fetchQuotes();
    }, []);

    return (
        <div className="max-w-6xl mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-slate-800 mb-6">Open Quotes</h1>

            {loading ? (
                <div className="space-y-4">
                    {[...Array(3)].map((_, i) => (
                        <QuoteDashboardSkeletonItem key={i} />
                    ))}
                </div>
            ) : dashQuotes.length > 0 ? (
                <div className="space-y-4">
                    {dashQuotes.map((quote) => (
                        <QuoteDashboardItem key={quote.id} quote={quote} />
                    ))}
                </div>
            ) : (
                <EmptyState />
            )}
        </div>
    );
};
